import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  USUARIO_PERFIL_DELETAR_BEGIN,
  USUARIO_PERFIL_DELETAR_SUCCESS,
  USUARIO_PERFIL_DELETAR_FAILURE,
  USUARIO_PERFIL_DELETAR_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function deletar(registro, callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: USUARIO_PERFIL_DELETAR_BEGIN,
    data: registro,
    callback,
  };
}

export function dismissDeletarError() {
  return {
    type: USUARIO_PERFIL_DELETAR_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on USUARIO_PERFIL_DELETAR_BEGIN actions
export function* doDeletar(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  let retorno;
  const UsuarioPerfilApi = new Services['UsuarioPerfilApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    retorno = yield UsuarioPerfilApi.deleteById(action.data.Codigo);
    if (retorno.count > 0) {
      res = action.data;
    } else {
      throw new Error('Falha ao excluir registro');
    }
  } catch (err) {
    yield put({
      type: USUARIO_PERFIL_DELETAR_FAILURE,
      data: { error: err },
    });

    if (action.callback) {
      action.callback(USUARIO_PERFIL_DELETAR_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: USUARIO_PERFIL_DELETAR_SUCCESS,
    data: res,
  });

  if (action.callback) {
    action.callback(USUARIO_PERFIL_DELETAR_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchDeletar() {
  yield takeLatest(USUARIO_PERFIL_DELETAR_BEGIN, doDeletar);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case USUARIO_PERFIL_DELETAR_BEGIN:
      return {
        ...state,
        deletarPending: true,
        deletarError: null,
      };

    case USUARIO_PERFIL_DELETAR_SUCCESS:
      return {
        ...state,
        registro: {},
        registros: state.registros.filter(registro => registro.Codigo !== action.data.Codigo),
        deletarPending: false,
        deletarError: null,
      };

    case USUARIO_PERFIL_DELETAR_FAILURE:
      return {
        ...state,
        deletarPending: false,
        deletarError: action.data.error,
      };

    case USUARIO_PERFIL_DELETAR_DISMISS_ERROR:
      return {
        ...state,
        deletarError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/usuario-perfil/redux/deletar.js